import { useState } from 'react';
import { Tooltip } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';
import type { ResellerDto } from '@/api/tmm/types';
import { StatusChip } from '@/status';

/** Display the published verdict, never infer it from status, standing or prices. */
export function PartnerSellable({
  tenant,
  focusable = true,
}: {
  tenant: ResellerDto['tenant'];
  focusable?: boolean;
}) {
  const { t } = useCopy();
  const [open, setOpen] = useState(false);
  if (!tenant) return <span>{t('partners.noTenant', 'No tenant yet')}</span>;
  const label = tenant.sellable
    ? t('partners.canSell', 'Can sell')
    : t('tenants.sellable.chip', "Can't sell");
  const reason =
    tenant.sellableReason === null
      ? label
      : t(`partners.sellableReason.${tenant.sellableReason}`, tenant.sellableReason);
  return (
    <Tooltip
      title={reason}
      describeChild
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
    >
      <StatusChip
        tabIndex={focusable ? 0 : undefined}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        tone={tenant.sellable ? 'success' : 'warning'}
        label={label}
      />
    </Tooltip>
  );
}
